/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiHomeGet } from '../fn/home/api-home-get';
import { ApiHomeGet$Params } from '../fn/home/api-home-get';
import { HtmlResp } from '../models/html-resp';

@Injectable({ providedIn: 'root' })
export class HomeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiHomeGet()` */
  static readonly ApiHomeGetPath = '/api/Home';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiHomeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHomeGet$Response(params?: ApiHomeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<HtmlResp>> {
    return apiHomeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiHomeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiHomeGet(params?: ApiHomeGet$Params, context?: HttpContext): Observable<HtmlResp> {
    return this.apiHomeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<HtmlResp>): HtmlResp => r.body)
    );
  }

}
